import axios from "axios";
import store from "store";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

import { ApiServerPath } from "api_server";
import { PLATFORM_SERVICES_COLLECTION } from "constants/global/firebase-collections";
import { sweetAlert } from "./global";

export const connectOpenAiAds = async (
  openaiApiKey: string,
) => {
  try {
    const trimmedApiKey = openaiApiKey?.trim();

    if (!trimmedApiKey) {
      sweetAlert("Please enter your OpenAI Ads API key");
      return false;
    }

    const { userData = {} }: any =
      store.getState().appReducer;
    const { lastSelectedWorkspace = {} } = userData;

    const workspaceId =
      lastSelectedWorkspace?.workspaceId;

    if (!workspaceId) {
      sweetAlert("Workspace not found. Please refresh and try again.");
      return false;
    }

    const { data } = await axios.post(
      `${ApiServerPath.API_SERVER_BASE_URL}${ApiServerPath.GET_OPENAI_AD_ACCOUNT}`,
      {
        openaiApiKey: trimmedApiKey,
        userInfo: { workspaceId },
      },
    );

    if (!data?.results?.success || !data?.results?.adAccount) {
      sweetAlert(
        data?.results?.error || "Failed to connect OpenAI Ads account",
        "error",
        null,
      );
      return false;
    }

    const { id, name, currency_code, preview_url } = data.results.adAccount;
    const ref = doc(PLATFORM_SERVICES_COLLECTION, workspaceId);
    const existingDoc = await getDoc(ref);

    const openAiAdsPayload = {
      isConnected: true,
      apiKey: trimmedApiKey,
      accountId: id,
      accountName: name,
      currencyCode: currency_code,
      logo_url: preview_url || "",
      userName: name || "OpenAI Ads",
      platformServiceName: "openAiAds",
      selectedOption: "30",
    };

    if (existingDoc.exists()) {
      await updateDoc(ref, {
        openAiAds: openAiAdsPayload,
      });
    } else {
      await setDoc(ref, {
        openAiAds: openAiAdsPayload,
      });
    }

    return true;
  } catch (error: any) {
    sweetAlert(
      error?.response?.data?.results?.error ||
        error?.message ||
        "Failed to connect OpenAI Ads account",
      "error",
      null,
    );
    return false;
  }
};
